
const api = {
	/* 公共 */
	login:'login',//登录
	regsiteuser:'regsiteuser',//注册
	sendsitecode:'sendsitecode',//发送验证码
	webconfig:'webconfig',//获取手机区域码
	checkcode:'checkcode',//校验验证码
	resetpwd:'resetpwd',//修改密码
	deleteaccount:'deleteaccount',//注销账号
	countryareas:'countryareas',//获取省市区

	// 订单相关
	getorderrule:'getorderrule',//下单规则
	reservewashorder:'reservewashorder',//一键下单
	getwashorderlist:'getwashorderlist',//订单列表
	getwashorderinfo:'getwashorderinfo',//订单详情
	getwashorderflow:'getwashorderflow',//订单追踪
	checkwashorder:'checkwashorder',//支付规则
	getcanuseticket:'getcanuseticket',//可用优惠券VIP卡
	washorderpay:'washorderpay',//订单支付
	cancelwashorder:'cancelwashorder',//取消订单

	// 个人中心
	intominepage:'intominepage',//个人中心
	getmyaddrlist:'getmyaddrlist',//地址列表
	editmyaddr:'editmyaddr',//添加编辑地址
	getmyvipcards:'getmyvipcards',//我的VIP卡
	activemycard:'activemycard',//激活VIP卡
	getmytickets:'getmytickets',//我的优惠券
	activemyticket:'activemyticket',//激活优惠券
	bindcorpcode:'bindcorpcode',//绑定公司代码
}


const config = {
	...api,
}
module.exports = config

